/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locales/nb': {
    width: 1200,
    height: 800,
    viewBox: '0 0 1200 800',
    data: '<path pid="0" _fill="#ef2b2d" d="M0 0h1200v800H0z"/><path pid="1" _fill="#fff" d="M325 0h200v800H325z"/><path pid="2" _fill="#fff" d="M0 300h1200v200H0z"/><path pid="3" _fill="#002868" d="M375 0h100v800H375z"/><path pid="4" _fill="#002868" d="M0 350h1200v100H0z"/>'
  }
})
